import { useState, useCallback } from "react";

function toDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function parseDate(dateStr: string): Date {
  return new Date(dateStr + "T00:00:00");
}

export function useDate(initial?: string) {
  const [date, setDate] = useState(initial ?? toDateString(new Date()));

  const goToPrev = useCallback(() => {
    setDate((d) => {
      const prev = parseDate(d);
      prev.setDate(prev.getDate() - 1);
      return toDateString(prev);
    });
  }, []);

  const goToNext = useCallback(() => {
    setDate((d) => {
      const next = parseDate(d);
      next.setDate(next.getDate() + 1);
      return toDateString(next);
    });
  }, []);

  const goToToday = useCallback(() => {
    setDate(toDateString(new Date()));
  }, []);

  return { date, setDate, goToPrev, goToNext, goToToday };
}

export function useYearMonth(initial?: string) {
  const now = new Date();
  const currentYearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  const [yearMonth, setYearMonth] = useState(initial ?? currentYearMonth);

  const isCurrentMonth = yearMonth === currentYearMonth;

  const goToPrev = useCallback(() => {
    setYearMonth((ym) => {
      const [y, m] = ym.split("-").map(Number);
      const prev = new Date(y, m - 2, 1);
      return `${prev.getFullYear()}-${String(prev.getMonth() + 1).padStart(2, "0")}`;
    });
  }, []);

  const goToNext = useCallback(() => {
    setYearMonth((ym) => {
      const [y, m] = ym.split("-").map(Number);
      const next = new Date(y, m, 1);
      const nextYm = `${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, "0")}`;
      // 이번 달을 초과할 수 없음
      if (nextYm > currentYearMonth) return ym;
      return nextYm;
    });
  }, [currentYearMonth]);

  return { yearMonth, setYearMonth, goToPrev, goToNext, isCurrentMonth, currentYearMonth };
}
